import React from 'react';

export interface IconSuccessProps {
  className?: string;
  size?: number | string;
  color?: string;
  fill?: string;
  stroke?: string;
}

const IconSuccess: React.FC<IconSuccessProps> = ({ 
  className = '', 
  size = 24, 
  color = 'currentColor', 
  fill, 
  stroke 
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 81 80"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      color={color}
      fill={fill || 'none'}
    >
       <rect x="0.5" width="80" height="80" rx="40" fill={fill || "#A7F3D0"} /> <path d="M53.0714 32.6667L37.3571 49.1667L29.5 40.9163" stroke={stroke || "#047857"}  strokeWidth="1.5" strokeLinecap="square" />  
    </svg>
  );
};

export default IconSuccess;
